import { useState, useEffect } from 'react';

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height
  };
}

export default function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());

  useEffect(() => {
    // Mobile browsers fire resize repeatedly while the address bar
    // collapses/expands during scroll. Anything reading width/height to
    // drive a live animation (e.g. the homepage blob's scale) would chase
    // those transient in-between sizes, reading as the element visibly
    // growing/shrinking mid-scroll. Debounce so we only react once the size
    // has actually settled.
    let timeoutId;
    function handleResize() {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => setWindowDimensions(getWindowDimensions()), 150);
    }

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
      clearTimeout(timeoutId);
    };
  }, []);

  return windowDimensions;
}
